import { CacheManage } from './cacheManageClass';

const cacheTable: { [key: string]: CacheManage } = {};

/**
 * テーブル用のキャッシュオブジェクトを新規作成する。
 * オブジェクト群を束にしたcacheTableをこのソースで保持しているので、importすればどこからでも同じデータを参照できる。
 * @param tableName
 * @param primaryKeyName
 * @param secondaryKeyName
 * @param email
 * @param adapters
 */
const prepareTable = async (
  tableName: string,
  primaryKeyName: string,
  secondaryKeyName?: any,
  email?: string,
  adapters?: any
): Promise<CacheManage> => {
  if (!(tableName in cacheTable)) {
    const tbl = await CacheManage.init(tableName, primaryKeyName, secondaryKeyName, email);
    if (adapters) {
      tbl.setup({
        createAdapter: adapters.createAdapter,
        updateAdapter: adapters.updateAdapter,
        bulkCreateAdapter: adapters.bulkCreateAdapter,
        bulkUpdateAdapter: adapters.bulkUpdateAdapter,
        deleteAdapter: adapters.deleteAdapter,
        readAdapter2: adapters.readAdapter2,
        readAllAdapter: adapters.readAllAdapter,
        flushForTestingAdapter: adapters.flushForTestingAdapter,
      });
    }
    cacheTable[tableName] = tbl;
  }
  return cacheTable[tableName];
};

const sleep = (ms: number) =>
  new Promise((resolve: any) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

/**
 * テーブル用のキャッシュオブジェクトを取得する。存在しなければ完成するまで待つ。
 * @param tableName
 */
const getTable = async (tableName: string): Promise<CacheManage> => {
  let count = 100;
  do {
    const tbl = cacheTable[tableName];
    if (tbl) return tbl;
    await sleep(50); // 100ms待ってみる
    count -= 1;
  } while (count > 0);
  if (typeof window !== 'undefined') {
    alert('cacheManageの初期化ができませんでした');
  }
  return {} as CacheManage;
};

/**
 *
 * @param tableName
 */
const getTableSync = (tableName: string): CacheManage => cacheTable[tableName];

/**
 * キャッシュオブジェクト全体を返す
 */
const getAllTables = () => cacheTable;

/**
 *
 * @param tableName
 */
const removeTable = (tableName: string) => {
  if (tableName in cacheTable) {
    delete cacheTable[tableName];
  }
};

/**
 *
 * @param primaryKeyValue
 * @param secondaryKeyValue
 */
const getKey = (primaryKeyValue: string, secondaryKeyValue: any): string | string[] => {
  if (secondaryKeyValue) {
    return [primaryKeyValue, secondaryKeyValue];
  }
  return primaryKeyValue;
};

export { getKey, getAllTables, getTableSync, prepareTable, getTable, removeTable };
